import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-style-guide';
import { Thumbnail2d, ThumbnailTypes, DefaultThumbnailSize } from 'roblox-thumbnails';

function UserAvatarHeadshot({ userId, profileLink }) {
  return (
    <Link url={profileLink} className='user-avatar-container avatar avatar-headshot-lg'>
      <Thumbnail2d
        type={ThumbnailTypes.avatarHeadshot}
        size={DefaultThumbnailSize}
        targetId={userId}
        containerClass='avatar-card-image'
      />
    </Link>
  );
}

UserAvatarHeadshot.propTypes = {
  userId: PropTypes.number.isRequired,
  profileLink: PropTypes.string.isRequired
};

export default UserAvatarHeadshot;
